import Image from 'app/Components/Shared/Image/image';

import React from 'react';
import errorIcon from './images/error.svg';
import './FamilyBundleErrorPopup.scss';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';

function PackageCanceledPopup({
    onClose
}) {

    const handleBuyNewPackage = () => {
        EpiContext.navigateTo(Config.abroadUrl );
    };

    const handleBackToPersonalArea = () => {
       onClose();
    };

    return (
        <div className="package-canceled-popup">
            <Image src={errorIcon} alt="error" className="popup-icon" />
            <div className='popup-text'>
                <span className='popup-title'>החבילה בוטלה בהצלחה</span>
            </div>

            <div className="popup-buttons">
                <button
                    className="continue-btn"
                    onClick={handleBuyNewPackage}
                >
                    רכישת חבילה חדשה
                </button>

                <button
                    className="secondary-btn"
                    onClick={handleBackToPersonalArea}
                >
                    חזרה לאיזור האישי
                </button>
            </div>
        </div>
    );
}

export default PackageCanceledPopup;
